import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CartViewPurchaseOptionsComponent } from 'cart-ui';
import { ProductResultLayoutComponentsProviderComponentBase, RenderInProductResultLayoutDirective } from 'products-ui';

@Component({
  selector: 'ideal-import-wire-cut-product-result-components',
  imports: [CartViewPurchaseOptionsComponent, RenderInProductResultLayoutDirective],
  standalone: true,
  templateUrl: './import-wire-cut-product-result-components.component.html',
  styleUrl: './import-wire-cut-product-result-components.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportWireCutProductResultComponentsComponent extends ProductResultLayoutComponentsProviderComponentBase {}
